import styled from 'foundations-theming/utils';
import { keyframes } from 'styled-components';
import { filterProps } from 'foundations-components/utils/filterProps';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const shimmerKeyframes = keyframes(["0%{background-position:-1000px 0;}100%{background-position:1000px 0;}"]);

// keyframes don't work with the Style Objects interface
const Animation = styled.div.withConfig({
  displayName: "SkeletonDiv__Animation",
  componentId: "e2rai-0"
})(["animation:", " 900ms infinite linear;"], shimmerKeyframes);
const StyledDiv = styled(Animation)(({
  $cssStyles,
  theme
}) => Object.assign({
  background: `linear-gradient(
    to right,
    ${theme.color['fill-surface-raised']} 8%,
    ${theme.color['fill-primary-disabled']} 48%,
    ${theme.color['fill-surface-raised']} 53%
  );`,
  backgroundSize: '2000px 100%'
}, $cssStyles));
export const SkeletonDiv = props => {
  const {
    domProps,
    tokenProps
  } = filterProps(props);
  const $styleProps = useMapTokenPropsToCSS(tokenProps);

  // @bend-expect trellis-tokenized Manually reviewed, customization of the skeleton div follow trellis tokenization requirements
  return /*#__PURE__*/_jsx(StyledDiv, Object.assign({
    $cssStyles: $styleProps
  }, domProps));
};